<template>
	<n-tooltip class="text-fs-xs! px-1.5! py-1!">
		<template #trigger>
			<n-tag :round :color="{ color: 'transparent' }" :size class="text-fs-sm font-normal">
				<template v-if="icon" #icon>
					<Icon :name="icon" :size="sizePX" />
				</template>
				{{ label }}
			</n-tag>
		</template>
		{{ $t(`patients.tags.abortion_gestational_age`) }}
	</n-tooltip>
</template>

<script setup lang="ts">
import type { I18nString } from "@/lang/config"
import type { PatientMeta } from "@/types/patient"
import { NTag, NTooltip } from "naive-ui"
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import Icon from "@/components/common/Icon.vue"
import { ICONS } from "@/const"

const { meta, size } = defineProps<{
	meta: PatientMeta
	round?: boolean
	size?: "small" | "medium" | "large" | "tiny"
}>()

const { t } = useI18n()

const sizePX = computed(() => (size === "small" ? 12 : size === "large" ? 16 : size === "tiny" ? 10 : 14))

const label = computed(() => `${meta.abortion_gestational_period?.weeks || 1}° ${t<I18nString>(`common.misc.week`)}`)

const icon = computed(() => ICONS.date)
</script>
